// extracted by mini-css-extract-plugin
export default {"link":"AtsGenre_link__GmLd-","skeleton":"AtsGenre_skeleton__5eTV6"};